import styled from 'styled-components';

export const ModalContainerDelete = styled.div`
  height: fit-content;
  margin-bottom: 0px;
  height: fit-content;

  h1 {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0px solid black;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 25px;
  }
  .aviso {
    border: 0px solid red;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    font-weight: regular;
    font-size: 18px;

    p {
      border: 0px solid red;
      text-align: justify;
      line-height: 20px;
    }

    p:nth-of-type(1) {
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
    p:nth-of-type(2) {
      margin-bottom: 10px;
    }

    svg {
      fill: red;
      font-size: 128px;
      margin-bottom: 4px;
    }
  }
`;
export const BotaoContainer = styled.div`
  display: flex;
  border: 0px solid red;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  margin-bottom: 0px;

  .btn {
    width: 50%;
    margin-bottom: 0px;
    margin-left: 25%;
  }
`;
export const ModalTitle = styled.h1`
  margin-bottom: 12%;
  margin-top: -2%;
`;

export const Paragraph = styled.p`
  text-align: center;
  margin-bottom: 4%;
`;

export const SpinnerConatainer = styled.div`
  border-color: 1px solid black;
  margin-left: 45%;
  margin-bottom: 5%;
    &.hide {
      display: none !important;
    }
`;
